import { render, staticRenderFns } from "./PlafondPanel.vue?vue&type=template&id=6ca01e0b&scoped=true"
import script from "./PlafondPanel.vue?vue&type=script&lang=js"
export * from "./PlafondPanel.vue?vue&type=script&lang=js"
import style0 from "./PlafondPanel.vue?vue&type=style&index=0&id=6ca01e0b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca01e0b",
  null
  
)

export default component.exports